/*------------------------------------------------------------------
Import modules
------------------------------------------------------------------*/
import inView from 'in-view';
import Tween from '@meteora-digital/tween';
/*------------------------------------------------------------------
In View events
------------------------------------------------------------------*/

inView.threshold(0.3);
inView('.js-in-view').on('enter', function (element) {
  setTimeout(function () {
    if (!element.classList.contains('in-view')) element.classList.add('in-view');
  }, 500);
}); // counter items

inView('.js-count').on('enter', function (el) {
  // This will animate the text
  var Counter = new Tween(); // Once the animation is finished we will grab this value and imsert it back into the element

  var baseText = el.innerHTML; // Set the element's innerHTML to the start value (0)

  el.innerHTML = 0; // When the tween has stopped, reset the

  Counter.on('end', function () {
    return el.innerHTML = baseText;
  }); // After a slight delay we will tween the Counter to it's desired value

  setTimeout(function () {
    Counter.tween({
      from: 0,
      to: parseInt(el.getAttribute('data-value')) || 0
    }, function (value) {
      return el.innerHTML = Math.round(value);
    }, 1000);
  }, 500);
}); // setup drawSVG

Meteora.each('.js-draw-svg svg, .js-draw-svg--large svg', function (svg) {
  drawSVG(svg);
});
inView('.js-draw-svg svg').on('enter', function (svg) {
  setTimeout(function () {
    svg.draw(1000);
  }, 500);
});
inView('.js-draw-svg--large svg').on('enter', function (svg) {
  setTimeout(function () {
    svg.draw(1500);
  }, 1000);
});